import { render, staticRenderFns } from "./QuotationList.vue?vue&type=template&id=478f1e4a&scoped=true&"
import script from "./QuotationList.vue?vue&type=script&lang=js&"
export * from "./QuotationList.vue?vue&type=script&lang=js&"
import style0 from "./QuotationList.vue?vue&type=style&index=0&id=478f1e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f1e4a",
  null
  
)

export default component.exports